var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { staticClass: "job-copy-form" },
    [
      _c("div", { staticStyle: { "text-align": "center" } }, [
        _c("b", { staticStyle: { "font-size": "large" } }, [
          _vm._v(_vm._s(_vm.$t("Tool.ResetJobCopyTittle")))
        ])
      ]),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: { label: _vm.$t("Tool.CheckedCategory") }
        },
        [
          _c(
            "el-select",
            {
              model: {
                value: _vm.checkedKey,
                callback: function($$v) {
                  _vm.checkedKey = $$v
                },
                expression: "checkedKey"
              }
            },
            _vm._l(_vm.checkedList, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { value: item.value, label: item.label }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm.checkedKey === "copy"
        ? _c("div", [
            _c("div", { staticStyle: { "text-align": "center" } }, [
              _c("p", { staticStyle: { color: "#8c939d" } }, [
                _vm._v(_vm._s(_vm.$t("Tool.ResetJobCopyMessage")))
              ])
            ])
          ])
        : _vm._e(),
      _vm.checkedKey === "provider"
        ? _c("div", [
            _c("div", { staticStyle: { "text-align": "center" } }, [
              _c("p", { staticStyle: { color: "#8c939d" } }, [
                _vm._v(_vm._s(_vm.$t("Tool.AfterCheckedSelection")))
              ])
            ])
          ])
        : _vm._e(),
      _c(
        "el-form-item",
        { staticClass: "save-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleReset } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }